import React, { useEffect } from "react";
import PropTypes from "prop-types";

import useOverflowYHidden from "hooks/useOverflowYHidden";
import styles from "./modal.scss";

const { modal_full_screen, left_section, right_section, modal_content, modal_title, modal_body, cross_icon, modal_footer } =
  styles;
export default function Modal({
  header,
  body,
  footer,
  showCloseButton,
  onCloseClick,
  disableBodyScroll,
  variant,
  blurBackground,
}) {
  useOverflowYHidden(disableBodyScroll);

  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  });

  return variant === "FULL_SCREEN" ? (
    <div className={modal_full_screen}>
      {showCloseButton && <span onClick={onCloseClick} className={cross_icon}></span>}
      <div className={modal_content}>
        <aside className={left_section}>
          <h3 className={modal_title}>{header}</h3>
        </aside>
        <div className={right_section}>
          <div className={modal_body}>{body}</div>
          <div className={modal_footer}>{footer}</div>
        </div>
      </div>
    </div>
  ) : (
    <div className={blurBackground ? styles.modalBackdrop : styles.modal}>
      <div className={styles.modalContent}>
        {onCloseClick && <span onClick={onCloseClick} className={styles.crossIcon}></span>}
        {header && <div className={styles.modalHeader}>{header}</div>}
        {body && (
          <div className={styles.modalBody}>
            <div className={styles.content_scroll}>{body}</div>
          </div>
        )}
        {footer && <div className={styles.modalFooter}> {footer}</div>}
      </div>
    </div>
  );
}

Modal.defaultProps = {
  disableBodyScroll: true,
  onCloseClick: () => {},
  showCloseButton: true,
};

Modal.propTypes = {
  header: PropTypes.node,
  body: PropTypes.node,
  footer: PropTypes.node,
  onCloseClick: PropTypes.func,
  showCloseButton: PropTypes.bool,
  disableBodyScroll: PropTypes.bool,
};
